module.exports = __webpack_public_path__ + "img/sonepar_sidebar.4723ae6c.webp";